const TYPE_PREFIX_MAP: Record<string, string> = {
  APARTAMENTO: "A",
  COBERTURA: "COB",
  CASA: "C",
  TERRENO: "T",
  POUSADA: "P",
  SALA: "S",
  CONJUNTO: "CJT",
  FLAT: "F",
};

const normalizeType = (type?: string): string => {
  if (!type) return "";

  return type
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();
};

export const getPropertyPrefixByType = (type?: string): string => {
  const normalizedType = normalizeType(type);
  return TYPE_PREFIX_MAP[normalizedType] || "IGT";
};

export const generatePropertyId = (
  type: string | undefined,
  codigo: number | undefined,
  id: number,
): string => {
  const displayNumber = codigo || id;
  const prefix = getPropertyPrefixByType(type);

  return `${prefix}${displayNumber}`;
};
